import { combineReducers } from "redux";
import userReducer from "./userReducer";
import loaderReducer from "./loaderReducer";

const rootReducer = combineReducers({
    user: userReducer,
    loader: loaderReducer,
})

export default rootReducer;